import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { buildHazardHubReportHtml, loadHazardHubReportPayload } from '../core/utils/hazard-hub.utils';

@Component({
  selector: 'app-hazard-hub-report-page',
  template: `<p *ngIf="missing" class="hh-report-missing">
    This HazardHub report is unavailable. Close this tab and open the report again from Spatial Analysis.
  </p>`,
  styles: [
    `
      .hh-report-missing {
        margin: 32px;
        font-family: Inter, Lato, system-ui, sans-serif;
        font-size: 16px;
        color: #2f353a;
      }
    `,
  ],
})
export class HazardHubReportPageComponent implements OnInit {
  missing = false;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    const reportId = this.route.snapshot.paramMap.get('reportId');
    if (!reportId) {
      this.missing = true;
      return;
    }

    const data = loadHazardHubReportPayload(reportId);
    if (!data) {
      this.missing = true;
      return;
    }

    const html = buildHazardHubReportHtml(data);
    document.open();
    document.write(html);
    document.close();
  }
}
